module.exports = __webpack_public_path__ + "img/30_28.0dee0d8f.png";